import React, { useState, useEffect } from 'react';
import {Modal, FormControl, Box, Tooltip, Typography, Snackbar, Alert,TextField, InputAdornment,
  Button, Checkbox, FormControlLabel, FormGroup, IconButton,CircularProgress 
} from '@mui/material';
import EditIcon from '@mui/icons-material/EditOutlined';
import { grey, red,blue } from '@mui/material/colors';

import BASE_URL from '../../config'

const style = {
  position: 'absolute', 
  top: '50%', 
  left: '50%', 
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white', 
  borderRadius: 4, 
  px: 4,
  py: 3, 
  outline: 'none', 
  width: { xs: '90%', sm: '500px' }, 
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 'auto', 
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  // Ocultar para Firefox
  scrollbarWidth: 'none',
  // Ocultar para Internet Explorer y Edge antiguo
  msOverflowStyle: 'none',
};

const Inputstyle = {
  '& .MuiOutlinedInput-root': {
    bgcolor: '#f5f5f5',
    borderRadius: '8px',
    '& fieldset': { borderColor: 'transparent' },
    '&:hover fieldset': { borderColor: grey[400] },
    '&.Mui-focused fieldset': { borderColor: grey[600] },
    '&.Mui-error fieldset': { borderColor: red[700] },
  },
};

export default function Editarcliente ({ cliente, refresh }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ nombre: '', empresa: '',email: '',phone: '',direccion: '' ,equipo: [] });
  const [confirmType, setConfirmType] = useState(null); 
  const [error, setError] = useState(false);
  const [nombresBD, setNombresBD]=useState([])
  const [loading, setLoading] = useState(false);

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  
  const isUsernameValid = form.nombre.trim().length > 6;
  const isCompanyValid = form.empresa.trim().length > 1;
  const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email);
  const isPhoneValid = form.phone.length === 10;
  const isAdresseValid = form.direccion.trim().length > 10;

  useEffect(() => {
      const fetchEquipos = async () => {
        try {
          const res = await fetch(`${BASE_URL}/clientes/getequipos`); 
          const data = await res.json();
          setNombresBD(data);
        } catch (err) {
          console.error("Error cargando equipos:", err);
        }
      };
      if (open) fetchEquipos();
    }, [open]);

  useEffect(() => {
    if (cliente && open) {
      setForm({
        nombre: cliente.nombre || '',
        empresa: cliente.empresa || '',
        email: cliente.email || '',
        phone: cliente.phone || '',
        direccion: cliente.direccion || '',
        equipo: cliente.equipo || []
      });
      setError(false);
      setConfirmType(null);
    }
  }, [cliente, open]);

  const handleCheck = (p) => {
    const nuevos = form.equipo.includes(p)
      ? form.equipo.filter(item => item !== p)
      : [...form.equipo, p];
    setForm({ ...form, equipo: nuevos });

  };

  const handleClose = () => {
    setConfirmType(null);
    setLoading(false);
    setError('');
    setForm({
      nombre: '', 
      empresa: '',
      email: '',
      phone: '',
      direccion: '',
      equipo: []
    });
    setOpen(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const limits = {
    empresa: 35,
    nombre: 40,
    email: 35,
    direccion:60,
    phone: 10,
    };

    if (limits[name] && value.length > limits[name]) {
      return;
    }

    // Lógica especial para el teléfono
    if (name === 'phone') {
      const onlyNums = value.replace(/[^0-9]/g, '');
      if (onlyNums.length <= 10) {
        setForm({ ...form, [name]: onlyNums });
      }
      return;
    }

    // Lógica para otros campos de texto (nombre, empresa, etc.)
    setForm({ ...form, [name]: value });
  };

  const validateAndOpenSave = () => {
    const isNombreEmpty = !form.nombre.trim();
    const isEmpresaEmpty = !form.empresa.trim();
    const isEmailEmpty = !form.email.trim();
    const isPhoneEmpty = !form.phone.trim();
    const isDireccionEmpty = !form.direccion.trim();
    const isEquipoEmpty = form.equipo.length === 0;

      if (isNombreEmpty || isEmpresaEmpty || isEmailEmpty || isPhoneEmpty || isDireccionEmpty || isEquipoEmpty ) {
      setError(true);
    } else {
      setError(false);
      setConfirmType('save');
    }
  };

  const handleUpdate = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${BASE_URL}/clientes/${cliente.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (res.ok) {
        setSnackbar({ open: true, message: 'Ajustes realizados con éxito', severity: 'success' });
        setTimeout(() => {
          if(refresh) refresh();
          handleClose();
        }, 1500); 
      } else {
        setError(data.message || 'Error al registrar el cliente.');
        setConfirmType(null); 
        setLoading(false);
      }
    } catch (e) {
      setError('Error de conexión con el servidor.');
      setConfirmType(null);
      setLoading(false);
    }
  }

  const boxstyle = { 
  mx:0.3, 
  my:0.3,  
  maxHeight: '60px',
  overflowY: 'auto', 
  bgcolor: '#ffffff',

  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: grey[300],
    borderRadius: '8px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: grey[500],
  },
  }

  const ConfirmView = () => (
    <Box sx={style}>
      <Typography variant="h6">
        {confirmType === 'cancel' ? '¿Cancelar edición?' : '¿Guardar cambios?'}
      </Typography>
      <Typography variant="body1" color='textSecondary' sx={{ mt: 1, mb: 3 }}>
        {confirmType === 'cancel' 
          ? '¿Estás seguro que deseas cancelar? Los cambios realizados se perderán.' 
          : '¿Estás seguro que deseas aplicar los cambios a este cliente?'}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'end' }}>
        <Button 
          variant="contained" 
          sx={{ bgcolor: grey[200], color: 'black', textTransform: 'none', px: 3}} 
          onClick={() => setConfirmType(null)}
        >
          {confirmType === 'cancel' ? 'No, continuar' : 'No, revisar'}
        </Button>
        <Button 
          variant="contained" 
          sx={{ bgcolor: 'black', color: 'white', textTransform: 'none', px: 3}}
          onClick={confirmType === 'cancel' ? () => setOpen(false) : handleUpdate}
        >
          {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> :confirmType === 'cancel' ? 'Sí, cancelar' : 'Sí, guardar'}
        </Button>
      </Box>
    </Box>
  );

  return (
    <>
      <IconButton onClick={() => setOpen(true)} 
      sx={{'&:hover': {color:grey[100], bgcolor: blue[400] } }}>
        <EditIcon fontSize="small" />
      </IconButton>

      <Modal open={open} onClose={() => setConfirmType('cancel')}>
        <Box>
          {confirmType ? <ConfirmView /> : (
            <Box sx={style}>
                  {/* TITULOS */}
                <Box sx={{ mb: 2 }}>
                  <Typography variant="h6">Editar Cliente</Typography>
                  <Typography variant="subtitle1" color='textSecondary'>Actualiza la información del cliente</Typography>
                </Box>

                  {/* FORMULARIO */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>

                  {/* EMPRESA */}
                  <FormControl>
                    <Typography sx={{ mb: 0.5 }}>Empresa</Typography>
                      <TextField 
                        fullWidth variant="outlined" sx={Inputstyle} 
                        size='small'
                        error={(form.empresa.length > 0 && !isCompanyValid) || (error && form.empresa.length === 0)}
                        helperText={(form.empresa.length > 0 && !isCompanyValid) || (error && form.empresa.length === 0) ? "Ingresa el nombre de la empresa" : ""}
                        value={form.empresa}
                        onChange={(e) => setForm({...form, empresa: e.target.value})} 
                      />
                  </FormControl>

                  {/* NOMBRE */}
                  <FormControl>
                    <Typography sx={{ mb: 0.5 }}>Nombre del Contacto</Typography>
                      <TextField 
                        size='small'
                        fullWidth rows={2} variant="outlined" sx={Inputstyle}
                        error={(form.nombre.length > 0 && !isUsernameValid) || (error && form.nombre.length === 0)}
                        helperText={(form.nombre.length > 0 && !isUsernameValid) || (error && form.nombre.length === 0) ? "Ingresa el nombre completo del contacto de la empresa" : ""}
                        value={form.nombre}
                        onChange={(e) => setForm({...form, nombre: e.target.value})} 
                      />
                  </FormControl>

                  {/* EMAIL */}  
                  <FormControl>
                    <Typography sx={{ mb: 0.5 }}>Email</Typography>
                      <TextField 
                        size='small'
                        name='email'
                        fullWidth rows={2} variant="outlined" sx={Inputstyle}
                        error={(form.email.length > 0 && !isEmailValid) || (error && form.email.length === 0)}
                        helperText={(form.email.length > 0 && !isEmailValid) || (error && form.email.length === 0) ? "Ingresa un correo válido" : ""}
                        value={form.email}
                        onChange={handleInputChange}
                      />       
                  </FormControl>

                  {/* TELEFONO */}
                  <FormControl>
                    <Typography sx={{ mb: 0.5 }}>Teléfono</Typography>
                      <TextField 
                        size='small'
                        name='phone'
                        fullWidth rows={2} variant="outlined" sx={Inputstyle}
                        error={(form.phone.length > 0 && !isPhoneValid) || (error && form.phone.length === 0)}
                        helperText={(form.phone.length > 0 && !isPhoneValid) || (error && form.phone.length === 0) ? "Se requieren 10 dígitos" : ""}
                        value={form.phone}
                        onChange={handleInputChange}
                        InputProps={{ startAdornment: <InputAdornment position="start">+52</InputAdornment> }}
                      />
                  </FormControl>

                  {/* DIRECCION */}
                  <FormControl>
                    <Typography sx={{ mb: 0.5 }}>Dirección</Typography>
                      <TextField 
                        size='small'
                        fullWidth 
                        multiline 
                        rows={2} 
                        variant="outlined" 
                        sx={Inputstyle}
                        value={form.direccion}
                        error={(form.direccion.length > 0 && !isAdresseValid) || (error && form.direccion.length === 0)}
                        helperText={(form.direccion.length > 0 && !isAdresseValid) || (error && form.direccion.length === 0) ? "Complete el campo" : ""}
                        onChange={(e) => setForm({...form, direccion: e.target.value})} 
                      />
                  </FormControl>

                  {/* EQUIPOS */}
                  <FormGroup>
                    <Typography sx={{ mb: 0.5 }}>Equipos</Typography>
                    <Tooltip 
                      title="Debes seleccionar al menos un equipo" 
                      open={error && form.equipo.length === 0} 
                      placement="top-end" 
                      arrow
                      componentsProps={{ tooltip: { sx: { bgcolor: red[700], fontWeight: 'bold' } }, arrow: { sx: { color: red[700] } } }}
                    >
                      <Box sx={{border: `1px solid ${error && form.equipo.length === 0 ? red[700] : grey[300]}`, 
                                borderRadius: '8px'}}>
                        <Box sx={boxstyle}>
                          {nombresBD.length > 0 ? nombresBD.map((nombre) => (
                            <Box
                              key={nombre}
                              sx={{
                                ':hover': { bgcolor: grey[100] },
                                display: 'flex',
                                alignItems: 'center',
                                height: '30px',
                                transition: 'background-color 0.2s ease',
                              }}>
                              <FormControlLabel
                                control={
                                  <Checkbox 
                                    sx={{
                                      ml: 1, 
                                      color: grey[400], 
                                      '&.Mui-checked': { color: 'black' } 
                                    }} 
                                    size="small" 
                                    checked={form.equipo.includes(nombre)} 
                                    onChange={() => handleCheck(nombre)}
                                  />
                                }
                                label={
                                  <Typography variant="body2" sx={{ userSelect: 'none', fontWeight: 500 }}>
                                    {nombre}
                                  </Typography>
                                }
                                sx={{ margin: 0, width: '100%' }}
                              />
                            </Box>
                          )) : (
                            <Box sx={{ p: 2, textAlign: 'center' }}>
                              <Typography variant="caption" sx={{ color: grey[500], fontStyle: 'italic' }}>
                                No hay equipos registrados.
                              </Typography>
                            </Box>
                          )}

                        </Box>
                      </Box>
                    </Tooltip>
                  </FormGroup>

                  {/* BOTONES */}
                  <Box sx={{ display: 'flex', gap: 2, justifyContent: 'end', mt: 1 }}>
                    <Button 
                      variant="contained" 
                      sx={{width: { xs: '40%', sm: '20%' } , bgcolor: grey[100], color: 'black', textTransform: 'none', px: 3, '&:hover': { bgcolor: grey[200] } }}
                      onClick={() => setConfirmType('cancel')}
                    >
                      Cancelar
                    </Button>
                    <Button 
                      variant="contained" 
                      sx={{width: { xs: '55%', sm: '38%' } , bgcolor: 'black', color: 'white', textTransform: 'none', px: 3, '&:hover': { bgcolor: '#333' } }}
                      onClick={validateAndOpenSave}
                    >
                      Guardar Cambios
                    </Button>
                  </Box>
                </Box>
              </Box>
            )}
        </Box>
      </Modal>
      <Snackbar 
        open={snackbar.open} 
        autoHideDuration={2500} 
        onClose={() => setSnackbar({...snackbar, open: false})} 
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity={snackbar.severity} variant="filled" sx={{ width: '100%', borderRadius: '10px' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}